<script lang="ts">
	let { announcement }: { announcement?: string } = $props();
</script>

{#if announcement}
	<div class="flex h-[var(--announcement-bar-height)] items-center justify-center bg-black p-2">
		<span class="text-center text-sm text-white">
			{@html announcement}
		</span>
	</div>

	<style>
		:root {
			--announcement-bar-height: 2.5rem;
		}
	</style>
{/if}
